import React, { useEffect, useState, useCallback, useRef } from "react";
import { 
  CreateTable,
  SuccessMessage,
  FailMessage,
  Loading,
  CustomerSelect,
  BOMItemSelect
} from "../common/APICommon";
import { apiUrl } from "../utils/Configuration";
import NoAccess from "./NoAccess";
import axios from 'axios';
import { motion, AnimatePresence } from "framer-motion";
import html2canvas from "html2canvas";
import jsPDF from "jspdf";
import RemoveCircleIcon from '@mui/icons-material/RemoveCircle';
import VisibilityIcon from '@mui/icons-material/Visibility';
import FilterAltIcon from '@mui/icons-material/FilterAlt';
import FactoryIcon from '@mui/icons-material/Factory';
import PersonSearchIcon from '@mui/icons-material/PersonSearch';

export default function Production() {
//#region Others
  const [loading, setLoading] = useState(false);
  const [successMessage, setSuccessMessage] = useState("");
  const [failMessage, setFailMessage] = useState("");
  const [filteredData, setFilteredData] = useState([]);
  const [search, setSearch] = useState("");

  const handleSearch = (value) => {
    setSearch(value);
    setCurrentPage(1)
    const lowerValue = value.toLowerCase();

    const filtered = filteredData.filter(
      (item) =>
        item.itemCode.toLowerCase().includes(lowerValue) ||
        item.itemDescription.toLowerCase().includes(lowerValue) ||
        item.customerCustomerId.toLowerCase().includes(lowerValue) ||
        item.customerName1.toLowerCase().includes(lowerValue) ||
        item.customerName2.toLowerCase().includes(lowerValue)
    );

    setData(filtered);
  };
//#endregion




//#region Filters
  const [showFilterForm, setShowFilterForm] = useState(false);
  const [customerFilter, setCustomerFilter] = useState(null);
  const [itemFilter, setItemFilter] = useState(null);
  const openFilterForm = () => {
    setShowFilterForm(true);
  }
  const closeFilterForm = () => {
    setShowFilterForm(false);
  }
//#endregion





//#region Variables
  const [selectedData, setSelectedData] = useState(null);

  const resetVariables = () => {
    setSelectedData(null);
  }
//#endregion






//#region View
  const [showViewForm, setViewForm] = useState(false);

  const openViewForm = () => {
    setViewForm(true);
  }
  const closeViewForm = () => {
    setViewForm(false);
    resetVariables();
  }

  const fetchDataById = useCallback(async (_data) => {
    try {
      const response = await axios.get(`${apiUrl}/api/Production/${_data?.id}` , {
        headers: { 'Content-Type': 'application/json'}
      })
        
      return (response.data)
    } catch (error) {
      console.error('Error fetching data:', error);
      return null
    }
  }, []);

  const viewHandleClick = async (_data) => {
    setLoading(true)

    const _selectedData = await fetchDataById(_data)
    setSelectedData(_selectedData)
    openViewForm();

    setLoading(false)
  }
//#endregion




//#region Table data
  const [currentPage, setCurrentPage] = useState(1);
  const [data, setData] = useState([]);

  const headers = [
    // 'ID', 
    'PRODUCTION DATE', 
    'CUSTOMER', 
    'ITEM', 
    'VOLUME', 
    'ACTIONS',
  ]
  const accessors = [
    // 'id', 
    'productionDate', 
    'customer', 
    'item', 
    'totalVolume', 
    'actions'
  ]

  const actions = [
    { 
      name: "View", 
      tooltip: "view",
      icon: <VisibilityIcon fontSize="small" />,
      className: "bg-sky-500 hover:bg-sky-600",
      function: viewHandleClick,
      visible: true,
    },
  ];

  const fetchData = useCallback(async () => {
    try {
      setLoading(true);

      const response = await axios.get(`${apiUrl}/api/Production/customer/${customerFilter?.customerId ?? "All"}/item/${itemFilter ? itemFilter?.itemCode : "All"}` , {
        headers: { 'Content-Type': 'application/json'}
      })
        
      setData(response.data)
      setFilteredData(response.data)
    } catch (error) {
      console.error('Error fetching data:', error);
    } finally {
      setLoading(false);
    }
  }, [customerFilter, itemFilter]);

  useEffect(() => {
    fetchData();
  }, [fetchData])
//#endregion


//#region Access Template
  const accountData = JSON.parse(localStorage.getItem("accountData"));
  
  if (!accountData?.accessTemplate?.hasProduction) {
    return <NoAccess />;
  }
//#endregion





//#region UI
  return (
    <>
      <div className="p-6 bg-gray-50 min-h-screen">
        {/* Header Section */}
        <div className="flex flex-col md:flex-row md:items-center justify-between mb-8 gap-4">
          <div>
            <h2 className="text-3xl font-bold text-gray-800 flex items-center gap-2">
              <FactoryIcon fontSize="large" className="text-theme-color" />
              {`Production (${data?.length ?? 0})`}
            </h2>
            <p className="text-gray-500 mt-1">Record of production.</p>
          </div>
          <div className="flex items-center gap-1">

            <button className="ml-5 bg-white border border-gray-300 text-theme-color hover:bg-gray-100 px-3 py-1 rounded-md flex items-center gap-2 hover:bg-opacity-90 transition"
              onClick={openFilterForm}
            >
              <FilterAltIcon/> Filter
            </button>
          </div>
        </div>

        {/* Search and Filters */}
        <div className="flex justify-between items-center gap-2">
          <div className="mb-4 w-full">
            <input
              type="text"
              placeholder="Search by description or ID..."
              className="px-4 py-2 border rounded-lg w-full md:w-2/3 focus:outline-none focus:ring-2 focus:ring-theme-color focus:border-theme-color"
              value={search}
              onChange={(e) => handleSearch(e.target.value)}
            />
            {/* Add filter dropdowns here if needed */}
          </div>
        </div>

        <CreateTable
          tableName={"Production"}
          headers={headers}
          accessors={accessors}
          data={data}
          actions={actions}

          currentPage={currentPage}
          setCurrentPage={setCurrentPage}
          itemsPerPage={10}
          totalItems={data?.length}
        />
      </div>

      <FilterModal 
        visible={showFilterForm}
        onClose={closeFilterForm}
        
        customerFilter={customerFilter} setCustomerFilter={setCustomerFilter}
        itemFilter={itemFilter} setItemFilter={setItemFilter}

        modalName={"Filter"}
      />

      <ProductionViewModal
        visible={showViewForm}
        onClose={closeViewForm}
        data={selectedData}
        modalName="Production Batch Overview"
      />

      <div className="fixed top-5 right-5 z-50 flex flex-col space-y-2">
        <SuccessMessage message={successMessage} onClose={() => setSuccessMessage("")} />
        <FailMessage message={failMessage} onClose={() => setFailMessage("")} />
      </div>

      { loading && <Loading />}
    </>
  );
//#endregion
}






const ProductionViewModal = ({
  visible,
  onClose,
  data, // Pass selectedData here (handles both single object or array)
  modalName = "Production Order Details",
}) => {
  const printRef = useRef(null);
  const [isDownloading, setIsDownloading] = useState(false);

  // Normalize data in case backend returns an array from .ToList()
  const productionData = Array.isArray(data) ? data[0] : data;

  if (!visible || !productionData) return null;

  // Header & Finished Item Info
  const productionId = productionData.productionId || productionData.ProductionId || `#${productionData.id || productionData.Id}`;
  const totalVolume = Number(productionData.totalVolume ?? productionData.TotalVolume ?? 0);
  
  // Customer Info
  const customer = productionData.customer || productionData.Customer || {};
  const customerName =
    productionData.customerName1 ||
    productionData.CustomerName1 ||
    customer.name1 ||
    customer.Name1 ||
    "N/A";
  const customerName2 =
    productionData.customerName2 ||
    productionData.CustomerName2 ||
    customer.name2 ||
    customer.Name2 ||
    "";
  const customerId =
    productionData.customerId ||
    productionData.CustomerId ||
    customer.customerId ||
    customer.CustomerId ||
    "N/A";
  const priceType =
    productionData.customerPriceType ||
    productionData.CustomerPriceType ||
    customer.priceType ||
    customer.PriceType ||
    "Standard";

  // Target Finished Good (Item)
  const item = productionData.item || productionData.Item || {};
  const itemCode = productionData.itemCode || productionData.ItemCode || item.itemCode || item.ItemCode || "N/A";
  const itemDescription =
    productionData.itemDescription ||
    productionData.ItemDescription ||
    item.itemDescription ||
    item.ItemDescription ||
    "Finished Good Product";
  const brandName = productionData.brandName || productionData.BrandName || item.brandName || item.BrandName || "";
  const categoryName = productionData.categoryName || productionData.CategoryName || item.categoryName || item.CategoryName || "";
  const uomName = productionData.uomName || productionData.UomName || item.salesUomName || item.SalesUomName || "Units";

  // Raw Materials / BOM Consumption Details
  const productionDetails =
    productionData.productionDetails ||
    productionData.ProductionDetails ||
    [];

  // Helper for numeric formatting
  const formatVal = (num, decimals = 2) => {
    return Number(num || 0).toLocaleString(undefined, {
      minimumFractionDigits: decimals,
      maximumFractionDigits: decimals,
    });
  };

  // PDF Export
  const handleDownloadPDF = async () => {
    const element = printRef.current;
    if (!element) return;

    setIsDownloading(true);
    try {
      const canvas = await html2canvas(element, {
        scale: 2,
        useCORS: true,
        logging: false,
        backgroundColor: "#ffffff",
        windowWidth: 1200,
        windowHeight: element.scrollHeight,
      });

      const imgData = canvas.toDataURL("image/png");
      const pdf = new jsPDF({
        orientation: "portrait",
        unit: "mm",
        format: "a4",
      });

      const imgWidth = 210;
      const imgHeight = (canvas.height * imgWidth) / canvas.width;

      pdf.addImage(imgData, "PNG", 0, 0, imgWidth, imgHeight);
      pdf.save(`Production_${productionId}.pdf`);
    } catch (error) {
      console.error("PDF Generation Error:", error);
    } finally {
      setIsDownloading(false);
    }
  };

  return (
    <AnimatePresence>
      <motion.div
        // initial={{ opacity: 0 }}
        // animate={{ opacity: 1 }}
        // exit={{ opacity: 0 }}
        className="fixed inset-0 bg-slate-900/50 backdrop-blur-sm flex items-center justify-center z-50 p-4"
      >
        <motion.div
          initial={{ scale: 0.95, opacity: 0, y: 20 }}
          animate={{ scale: 1, opacity: 1, y: 0 }}
          exit={{ scale: 0.95, opacity: 0, y: 20 }}
          className="bg-gray-100 rounded-2xl shadow-2xl w-full max-w-7xl overflow-hidden flex flex-col max-h-[92vh]"
        >
          {/* Modal Header */}
          <div className="px-8 py-5 bg-white border-b border-gray-200 flex justify-between items-center">
            <div>
              <h2 className="text-2xl font-bold text-gray-800 tracking-tight">
                {modalName}
              </h2>
              <p className="text-sm text-gray-500">
                Production batch summary, recipe details, and material variance
              </p>
            </div>
            <button
              onClick={onClose}
              className="text-gray-400 hover:text-gray-600 transition p-2 hover:bg-gray-100 rounded-full"
            >
              <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12" />
              </svg>
            </button>
          </div>

          {/* Printable Document Body */}
          <div className="p-8 overflow-y-auto custom-scrollbar flex-grow">
            <div
              ref={printRef}
              className="max-w-4xl mx-auto bg-white shadow-xl border border-gray-200 rounded-sm p-12 min-h-[850px] flex flex-col justify-between"
            >
              <div>
                {/* 1. Document Title & Header */}
                <div className="flex justify-between items-start border-b-4 border-theme-color pb-8 mb-8">
                  <div>
                    <h1 className="text-4xl font-black text-theme-color tracking-tighter mb-2">
                      PRODUCTION ORDER
                    </h1>
                    <div className="flex items-center gap-3">
                      <span className="px-3 py-1 rounded-full text-[10px] font-bold uppercase tracking-wider bg-emerald-100 text-emerald-700">
                        Completed
                      </span>
                      <span className="text-xs font-semibold text-gray-400">
                        Category: {categoryName || "Manufacturing"}
                      </span>
                    </div>
                  </div>
                  <div className="text-right">
                    <p className="text-[10px] font-bold text-gray-400 uppercase tracking-widest">
                      Production ID
                    </p>
                    <p className="text-2xl font-mono font-bold text-theme-color">
                      {productionId}
                    </p>
                    <div className="mt-3 text-right">
                      <p className="text-[9px] font-bold text-gray-400 uppercase">
                        Production Date
                      </p>
                      <p className="text-xs font-bold text-gray-800">
                        {data.productionDate ? new Date(data.productionDate).toLocaleDateString() : "-"}
                      </p>
                    </div>
                  </div>
                </div>

                {/* 2. Target Output & Customer Info Cards */}
                <div className="grid grid-cols-3 gap-6 mb-8">
                  {/* Finished Good Output Item */}
                  <div className="col-span-2 bg-gray-50 p-6 rounded-xl border border-gray-100">
                    <h3 className="text-[11px] font-bold text-theme-color uppercase tracking-[0.2em] border-b border-gray-200 pb-2 mb-3">
                      Finished Product Details (Target Output)
                    </h3>
                    <div className="flex justify-between items-start">
                      <div>
                        <p className="font-bold text-gray-900 text-lg leading-tight">
                          {itemDescription}
                        </p>
                        <div className="flex items-center gap-3 mt-1.5 text-xs text-gray-500">
                          <span>Code: <strong className="font-mono text-gray-700">{itemCode}</strong></span>
                          {brandName && <span>• Brand: {brandName}</span>}
                          {categoryName && <span>• Category: {categoryName}</span>}
                        </div>
                      </div>
                      <div className="text-right pl-4">
                        <span className="text-[10px] uppercase font-bold text-gray-400 tracking-wider">
                          Target Volume
                        </span>
                        <div className="text-xl font-black text-theme-color">
                          {formatVal(totalVolume)} <span className="text-xs font-semibold">{uomName}</span>
                        </div>
                      </div>
                    </div>
                  </div>

                  {/* Customer / Client */}
                  <div className="col-span-1 bg-gray-50 p-6 rounded-xl border border-gray-100 flex flex-col justify-between">
                    <div>
                      <h3 className="text-[11px] font-bold text-theme-color uppercase tracking-[0.2em] border-b border-gray-200 pb-2 mb-3">
                        Client / Customer
                      </h3>
                      <p className="font-bold text-gray-900 text-base leading-snug">
                        {customerName}
                      </p>
                      {customerName2 && (
                        <p className="text-xs text-gray-500 mt-0.5">{customerName2}</p>
                      )}
                      <p className="text-xs text-gray-400 mt-2 font-mono">
                        ID: {customerId}
                      </p>
                    </div>
                    <div className="mt-3 pt-2 border-t border-gray-200 flex justify-between text-xs">
                      <span className="text-gray-400 font-medium">Price Type:</span>
                      <span className="font-semibold text-gray-700">{priceType}</span>
                    </div>
                  </div>
                </div>

                {/* 3. Raw Materials (BOM) Table */}
                <div className="mb-8">
                  <div className="flex justify-between items-center mb-2">
                    <h4 className="text-xs font-bold text-gray-700 uppercase tracking-wider">
                      Ingredients / Raw Materials Consumed ({productionDetails.length})
                    </h4>
                  </div>
                  <table className="w-full">
                    <thead>
                      <tr className="bg-theme-color text-white">
                        <th className="py-3 px-4 text-left text-[10px] font-bold uppercase tracking-widest">
                          Item / Material
                        </th>
                        <th className="py-3 px-3 text-center text-[10px] font-bold uppercase tracking-widest">
                          UOM
                        </th>
                        <th className="py-3 px-4 text-right text-[10px] font-bold uppercase tracking-widest">
                          Planned
                        </th>
                        <th className="py-3 px-4 text-right text-[10px] font-bold uppercase tracking-widest">
                          Actual Used
                        </th>
                        <th className="py-3 px-4 text-right text-[10px] font-bold uppercase tracking-widest">
                          Moisture Corr.
                        </th>
                      </tr>
                    </thead>
                    <tbody className="divide-y divide-gray-100 border-b border-gray-200">
                      {productionDetails.length > 0 ? (
                        productionDetails.map((detail, idx) => {
                          const planned = Number(detail.planned ?? detail.Planned ?? 0);
                          const actual = Number(detail.actualUsed ?? detail.ActualUsed ?? 0);
                          const moisture = Number(detail.moistureCorrected ?? detail.MoistureCorrected ?? 0);
                          const detailItem = detail.item || detail.Item || {};
                          const desc =
                            detail.itemDescription ||
                            detail.ItemDescription ||
                            detailItem.itemDescription ||
                            detailItem.ItemDescription ||
                            "Raw Material";
                          const code = detail.itemCode || detail.ItemCode || detailItem.itemCode || "---";
                          const uom = detail.uomName || detail.UomName || "KG";

                          return (
                            <tr key={idx} className="hover:bg-gray-50/50 transition-colors">
                              <td className="py-4 px-4">
                                <p className="text-sm font-bold text-gray-800">{desc}</p>
                                <p className="text-[10px] text-gray-400 font-mono">CODE: {code}</p>
                              </td>
                              <td className="py-4 px-3 text-center text-xs font-semibold text-gray-500 uppercase">
                                {uom}
                              </td>
                              <td className="py-4 px-4 text-right text-sm font-medium text-gray-600">
                                {formatVal(planned)}
                              </td>
                              <td className="py-4 px-4 text-right text-sm font-bold text-gray-900">
                                {formatVal(actual)}
                              </td>
                              <td className="py-4 px-4 text-right text-sm font-medium text-gray-500">
                                {formatVal(moisture)}
                              </td>
                            </tr>
                          );
                        })
                      ) : (
                        <tr>
                          <td colSpan="6" className="py-10 text-center text-sm text-gray-400 italic">
                            No raw materials linked to this production order
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                </div>

                {/* 4. Production Summary & KPI Breakdown */}
                <div className="mt-8 flex justify-between items-start gap-12">
                  <div className="flex-1">
                    <h4 className="text-[10px] font-black text-gray-900 uppercase tracking-widest mb-2">
                      Batch Notes / Quality Control
                    </h4>
                    <p className="text-xs text-gray-500 leading-relaxed bg-gray-50 p-4 rounded-lg border border-dashed border-gray-200 min-h-[75px]">
                      Standard production run verified against formulation. Moisture correction factors applied where specified.
                    </p>
                  </div>

                  {/* Summary Totals Card */}
                  <div className="w-80 space-y-2.5 bg-gray-50 p-5 rounded-xl border border-gray-100">

                    <div className="flex justify-between items-center pt-3 ">
                      <span className="text-xs font-black text-gray-900 uppercase">
                        Total Output
                      </span>
                      <span className="text-2xl font-black text-theme-color tracking-tighter">
                        {formatVal(totalVolume)} {uomName}
                      </span>
                    </div>
                  </div>
                </div>
              </div>

              {/* Document footer timestamp */}
              <div className="text-[10px] text-gray-400 text-center pt-6 border-t border-gray-100 mt-8">
                System Generated Production Report • Ref: {productionId}
              </div>
            </div>
          </div>

          {/* Modal Action Buttons */}
          <div className="px-8 py-5 border-t bg-white flex justify-end items-center space-x-4">
            <button
              onClick={onClose}
              className="px-6 py-2.5 rounded-lg border border-gray-300 text-gray-600 hover:bg-gray-50 transition font-semibold text-sm"
            >
              Close
            </button>
            <button
              onClick={handleDownloadPDF}
              disabled={isDownloading}
              className={`px-8 py-2.5 rounded-lg bg-theme-color text-white font-bold shadow-lg shadow-theme-color/20 transition active:scale-95 text-sm flex items-center gap-2 ${
                isDownloading ? "opacity-70 cursor-not-allowed" : "hover:opacity-90"
              }`}
            >
              {isDownloading ? (
                <>
                  <svg
                    className="animate-spin h-4 w-4 text-white"
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 24 24"
                  >
                    <circle
                      className="opacity-25"
                      cx="12"
                      cy="12"
                      r="10"
                      stroke="currentColor"
                      strokeWidth="4"
                    ></circle>
                    <path
                      className="opacity-75"
                      fill="currentColor"
                      d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                    ></path>
                  </svg>
                  Generating PDF...
                </>
              ) : (
                <>
                  <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M4 16v1a3 3 0 003 3h10a3 3 0 003-3v-1m-4-4l-4 4m0 0l-4-4m4 4V4" />
                  </svg>
                  Download PDF
                </>
              )}
            </button>
          </div>
        </motion.div>
      </motion.div>
    </AnimatePresence>
  );
};





















//#region Filter
const FilterModal = ({
  visible, onClose, modalName,
  customerFilter, setCustomerFilter,
  itemFilter, setItemFilter,
}) => {
  const [failMessage, setFailMessage] = useState("");
  const [_customerFilter, _setCustomerFilter] = useState(customerFilter);
  const [_itemFilter, _setItemFilter] = useState(itemFilter);

  useEffect(() => {
    if(visible){
      _setCustomerFilter(customerFilter)
      _setItemFilter(itemFilter)
    }
  }, [visible, customerFilter, itemFilter ])

  const handleSubmit = async () => {
    setCustomerFilter(_customerFilter);
    setItemFilter(_itemFilter);
    closeModal();
  };

  const resetLocalVariables = () => {
    setFailMessage("");
  };

  const closeModal = () => {
    onClose();
    resetLocalVariables();
  };

//#region Customer
  const [showCustomerSelectForm, setShowCustomerSelectForm] = useState(false);
  const openCustomerSelectForm = () => {
    setShowCustomerSelectForm(true);
  }
  const closeCustomerSelectForm = () => {
    setShowCustomerSelectForm(false);
  }
//#endregion




//#region Item
  const [showItemSelectForm, setShowItemSelectForm] = useState(false);
  const openItemSelectForm = () => {
    setShowItemSelectForm(true);
  }
  const closeItemSelectForm = () => {
    setShowItemSelectForm(false);
  }
//#endregion

  if (!visible) return null;

  return (
    <>
      {/* Background overlay */}
      <AnimatePresence>
        {visible && (
          <motion.div
            // initial={{ opacity: 0 }}
            // animate={{ opacity: 1 }}
            // exit={{ opacity: 0 }}
            className="fixed inset-0 bg-gray-200 bg-opacity-70 flex items-center justify-center z-50"
          >
            {/* Modal container */}
            <motion.div
              initial={{ scale: 0.9, opacity: 0 }}
              animate={{ scale: 1, opacity: 1 }}
              exit={{ scale: 0.9, opacity: 0 }}
              transition={{ duration: 0.2 }}
              className="bg-gray-100 rounded-2xl shadow-lg w-full max-w-lg p-8"
            >
              <h2 className="text-2xl font-semibold border-b pb-3 mb-6">
                {modalName}
              </h2>

              <div className="space-y-5 max-h-[500px] overflow-y-auto short:max-h-[300px] medium:h-[400px] pr-1">
                <div>
                  <label className="block text-sm font-semibold mb-1 text-gray-700">
                    Customer
                  </label>
                  <div className="flex flex-row items-center">
                    <input
                      type="text"
                      placeholder="Select Customer"
                      className="w-full border border-gray-300 text-sm rounded-l-lg px-3 py-2 text-gray-800 focus:outline-none focus:ring-2 focus:ring-theme-color focus:border-theme-color transition"
                      value={`${_customerFilter ? `${_customerFilter?.customerId} - ${_customerFilter?.name1}` : ""}`}
                      readOnly
                    />
                    {!_customerFilter ?
                      <button className="bg-theme-color hover:bg-theme-color-h p-[5px] rounded-r-lg" onClick={openCustomerSelectForm}>
                        <PersonSearchIcon className="text-white"/>
                      </button> 
                      :
                      <button className="bg-red-400 hover:bg-red-500 p-[5px] rounded-r-lg" onClick={()=>_setCustomerFilter(null)}>
                        <RemoveCircleIcon className="text-white"/>
                      </button>
                    }
                  </div>
                </div>

                <div>
                  <label className="block text-sm font-semibold mb-1 text-gray-700">
                    Item
                  </label>
                  <div className="flex flex-row items-center">
                    <input
                      type="text"
                      placeholder="Select Item"
                      className="w-full border border-gray-300 text-sm rounded-l-lg px-3 py-2 text-gray-800 focus:outline-none focus:ring-2 focus:ring-theme-color focus:border-theme-color transition"
                      value={`${_itemFilter ? `${_itemFilter?.itemCode} - ${_itemFilter?.itemDescription} ${_itemFilter?.brandName ? `(${_itemFilter.brandName})` : ''}` : ""}`}
                      readOnly
                    />
                    {!_itemFilter ?
                      <button className="bg-theme-color hover:bg-theme-color-h p-[5px] rounded-r-lg" onClick={openItemSelectForm}>
                        <PersonSearchIcon className="text-white"/>
                      </button> 
                      :
                      <button className="bg-red-400 hover:bg-red-500 p-[5px] rounded-r-lg" onClick={()=>_setItemFilter(null)}>
                        <RemoveCircleIcon className="text-white"/>
                      </button>
                    }
                  </div>
                </div>
              </div>

              {/* Buttons */}
              <div className="flex justify-end space-x-3 mt-8 border-t pt-4">
                <button
                  onClick={closeModal}
                  className="px-5 py-2 rounded-lg border border-gray-300 text-gray-700 hover:bg-gray-100 transition"
                >
                  Cancel
                </button>
                <button
                  onClick={handleSubmit}
                  className="px-5 py-2 rounded-lg bg-theme-color text-white font-medium hover:opacity-90 transition"
                >
                  Save
                </button>
              </div>
            </motion.div>
          </motion.div>
        )}
      </AnimatePresence>
      
      <CustomerSelect 
        visible={showCustomerSelectForm} 
        onClose={closeCustomerSelectForm}
        modalName={"Select Customer"}
        data={_customerFilter} setData={_setCustomerFilter}
      />

      <BOMItemSelect 
        visible={showItemSelectForm} 
        onClose={closeItemSelectForm}
        modalName={"Select Item"}
        data={_itemFilter} setData={_setItemFilter}
      />

      {/* Alert */}
      <div className="fixed top-5 right-5 z-[9999] flex flex-col space-y-2">
        <FailMessage message={failMessage} onClose={() => setFailMessage("")} />
      </div>
    </>
  );
};
//#endregion